// extracted by mini-css-extract-plugin
export default {"products":"ys-z","card":"zs-z","oosMessaging":"As-z"};